/** Valid dashboard page ids — keep in sync with App.tsx routes and Layout nav. */
export const DASHBOARD_PAGES = [
  'licenses',
  'users',
  'audits',
  'siteMonitoring',
  'pendingUpdates',
  'aiSettings',
  'inukaUsers',
  'pricingPlans',
  'paymentSettings',
  'websiteContent',
  'blogs',
  'websiteAuditLogs',
] as const;

export type DashboardPage = (typeof DASHBOARD_PAGES)[number];

export function isDashboardPage(page: string): page is DashboardPage {
  return (DASHBOARD_PAGES as readonly string[]).includes(page);
}

export const LICENSE_HUB_TABS = ['overview', 'limits'] as const;
export type LicenseHubTab = (typeof LICENSE_HUB_TABS)[number];

const PAGE_KEY = 'dashboard_current_page';
const LICENSE_TAB_KEY = 'license_hub_tab';

export function readStoredPage(): DashboardPage {
  try {
    const saved = localStorage.getItem(PAGE_KEY);
    if (saved && isDashboardPage(saved)) {
      return saved;
    }
  } catch {
    /* ignore */
  }
  return 'licenses';
}

export function storePage(page: string): void {
  try {
    localStorage.setItem(PAGE_KEY, page);
  } catch {
    /* ignore */
  }
}

export function readStoredLicenseTab(): LicenseHubTab {
  try {
    const saved = localStorage.getItem(LICENSE_TAB_KEY);
    if (saved === 'licenses') {
      return 'overview';
    }
    if (saved && (LICENSE_HUB_TABS as readonly string[]).includes(saved)) {
      return saved as LicenseHubTab;
    }
  } catch {
    /* ignore */
  }
  return 'overview';
}

export function storeLicenseTab(tab: LicenseHubTab): void {
  try {
    localStorage.setItem(LICENSE_TAB_KEY, tab);
  } catch {
    /* ignore */
  }
}
